import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, LogOut, ShoppingBag, Heart, UserCircle } from 'lucide-react';

const UserMenu = ({ isAuthenticated, user, onLoginClick, onProfileClick, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = isAuthenticated ? [
    { icon: <UserCircle className="w-4 h-4" />, label: 'Mi perfil', onClick: onProfileClick },
    { icon: <ShoppingBag className="w-4 h-4" />, label: 'Mis pedidos', onClick: () => {} },
    { icon: <Heart className="w-4 h-4" />, label: 'Wishlist', onClick: () => {} },
    { icon: <LogOut className="w-4 h-4" />, label: 'Cerrar sesión', onClick: onLogout, className: 'text-destructive' }
  ] : [
    { label: 'Iniciar sesión', onClick: onLoginClick },
    { label: 'Registrarse', onClick: onLoginClick }
  ];

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative p-2 hover:bg-muted rounded-full transition-colors"
        aria-label="Menú de usuario"
      >
        {isAuthenticated && user?.avatar ? (
          <img
            src={user.avatar}
            alt={user.nombre}
            className="w-8 h-8 rounded-full"
          />
        ) : (
          <User className="w-5 h-5" />
        )}
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            <div
              className="fixed inset-0 z-40"
              onClick={() => setIsOpen(false)}
            />
            <motion.div
              initial={{ opacity: 0, y: 10, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 10, scale: 0.95 }}
              transition={{ duration: 0.15 }}
              className="absolute top-full right-0 mt-2 bg-background border border-border rounded-lg shadow-xl w-56 z-50 overflow-hidden"
            >
              {isAuthenticated && user && (
                <div className="p-4 border-b border-border">
                  <p className="font-medium text-sm">{user.nombre}</p>
                  <p className="text-xs text-muted-foreground truncate">{user.email}</p>
                </div>
              )}
              <div className="py-2">
                {menuItems.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      item.onClick();
                      setIsOpen(false);
                    }}
                    className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-muted transition-colors ${
                      item.className || ''
                    }`}
                  >
                    {item.icon}
                    <span>{item.label}</span>
                  </button>
                ))}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default UserMenu;